import React, { useEffect, useRef } from "react";
import Button from "../button";
import ModalTemplate from "./template";
import { useDispatch, useSelector } from "react-redux";
import { acceptPrize } from "../../../redux/actions/bidding";
import { State } from "../../../redux/reducers/root";
import { hideModal } from "../../../redux/actions/modals";
import { useHistory } from "react-router-dom";
import BiddingIcon from "../../../static/images/svgs/bidding";

function useOutsideClick(ref: any, doctorId: number) {
  const history = useHistory();
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        history.push(`/doctors/${doctorId}/dashboard`);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const BiddingPrizeModal = () => {
  const doctor = useSelector((state: State) => state.selectDoctor);
  const dispatch = useDispatch();

  const wrapperRef = useRef(null);
  doctor?.id && useOutsideClick(wrapperRef, doctor.id);

  const onSubmit = async () => {
    doctor?.id && (await dispatch(acceptPrize(doctor.id)));
    hideModal();
    location.reload();
  };

  return (
    <div ref={wrapperRef}>
      <div className="flex justify-center w-full">
        <BiddingIcon />
      </div>
      {/* <img src={bidding} className='mx-auto' /> change bidding svg component */}
      <ModalTemplate
        title="50,000 تومان هدیه افزایش بازدید"
        titleClass="w-full flex justify-center mt-6 text-base"
        containerClass="w-full"
      >
        <div className="flex flex-col ">
          <p className="mt-6 text-sm text-pkc-description-text">
            با فعال‌سازی و استفاده از طرح افزایش بازدید، بازخورد بسیار بهتری از پزشک خوب دریافت کنید.
            <br />
            به محض فعال‌سازی 50 هزار تومان اعتبار هدیه به شما تعلق خواهد گرفت.
          </p>
          <Button className="mt-6" onClick={onSubmit}>
            دریافت هدیه
          </Button>
        </div>
      </ModalTemplate>
    </div>
  );
};

export default BiddingPrizeModal;
